





























































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { CspInquiry, ProjectInquiry } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class SingleInquiryEng extends Vue {
    public isDisabled: boolean = true;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public inquiryStatusType = enums.inquiryStatusType3;
    public labelPosition: string = 'right';

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.startTime = value[0];
            this.searchValue.endTime = value[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
    statusArr: any = [];
    public searchValue: any = {
        startTime: '',
        endTime: '',
        code: '',
        inquiryWay: '',
        statusListStr: '',
        projectCode: '',
        projectName: '',
        orderBy: '',
    };
    public tableData: Array<type.CspInquiryListItem> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    //根据权限判断按钮显隐
    public gcb3: boolean = false;
    public gcz3: boolean = false;
    public gcs3: boolean = false;
    public gcbl3: boolean = false;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        // let webMenus = sessionStorage.getItem('webMenus') ? sessionStorage.getItem('webMenus') : localStorage.getItem('webMenus');
        this.gcb3 = webMenus.includes('gcb3');
        this.gcz3 = webMenus.includes('gcz3');
        this.gcs3 = webMenus.includes('gcs3');
        this.gcbl3 = webMenus.includes('gcbl3');
    }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        if (this.$route.query.type === 'dashboard') {
            this.searchValue = {
                startTime: '',
                endTime: '',
                code: '',
                inquiryWay: '',
                statusListStr: '',
                projectCode: '',
                projectName: '',
                orderBy: '',
            };
            this.timeList = [];
            this.statusArr = ['3'];
            this.searchValue.statusListStr = '3';
            this.searchFunc();
            this.isActive = true;
        } else {
            if (sessionStorage.getItem('SingleInquiryEng_searchValue')) {
                this.searchValue = JSON.parse(sessionStorage.getItem('SingleInquiryEng_searchValue'));
                this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
                this.statusArr = sessionStorage.getItem('SingleInquiryEng_statusArr')
                    ? JSON.parse(sessionStorage.getItem('SingleInquiryEng_statusArr'))
                    : [];

                this.searchPagin = sessionStorage.getItem('SingleInquiryEng_page')
                    ? JSON.parse(sessionStorage.getItem('SingleInquiryEng_page'))
                    : this.searchPagin;
                this.getInquiryList();
            } else {
                this.searchPagin = sessionStorage.getItem('SingleInquiryEng_page')
                    ? JSON.parse(sessionStorage.getItem('SingleInquiryEng_page'))
                    : this.searchPagin;
                this.getInquiryList();
            }
            this.isActive = sessionStorage.getItem('SingleInquiryEng_isActive')
                ? JSON.parse(sessionStorage.getItem('SingleInquiryEng_isActive'))
                : false;
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'code':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'inquiryWayStr':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            // case 'creationTime':
            //     {
            //         this.searchValue.orderBy = '3';
            //     }
            //     break;
            // case 'carLength':
            //     {
            //         this.searchValue.orderBy = '4';
            //     }
            //     break;
            case 'isOpenInvoice':
                {
                    this.searchValue.orderBy = '5';
                }
                break;
            case 'preDeliveryTime':
                {
                    this.searchValue.orderBy = '6';
                }
                break;
            case 'priceEndTime':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'statusStr':
                {
                    this.searchValue.orderBy = '4';
                }
                break;
        }
        this.getInquiryList();
    }

    public toOrder(data) {}

    public toEdit(data) {
        sessionStorage.setItem('SingleInquiryEng_isActive', JSON.stringify(this.isActive));
        this.$router.push({
            path: '/addInquiryEng',
            query: {
                id: data.id,
                type: 'edit',
            },
        });
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public async exportExcel() {
        this.searchValue.statusListStr = this.statusArr.join();
        let data = await ProjectInquiry.Export(this.searchValue);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }

    public getInquiryList() {
        this.loading = true;
        this.searchValue.statusListStr = this.statusArr.join();
        ProjectInquiry.GetList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        sessionStorage.setItem('SingleInquiryEng_searchValue', JSON.stringify(this.searchValue));
        sessionStorage.setItem('SingleInquiryEng_statusArr', JSON.stringify(this.statusArr));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('SingleInquiryEng_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        sessionStorage.setItem('SingleInquiryEng_page', JSON.stringify(this.searchPagin));
        sessionStorage.setItem('SingleInquiryEng_isActive', JSON.stringify(this.isActive));
        this.$router.push({
            path: '/inquiryDetail',
            query: {
                type: 'view',
                id: item.id,
            },
        });
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    handleSelectionChange(rows) {
        this.selectionRow = rows;
        if (rows.length > 1) {
            this.$refs.multipleTable.clearSelection();
            this.$refs.multipleTable.toggleRowSelection(rows.pop());
        }
        if (rows.length != 0) {
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
        }
    }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type) {
        sessionStorage.setItem('SingleInquiryEng_isActive', JSON.stringify(this.isActive));
        if (type == 1) {
            this.$router.push({
                path: '/inquiryDetailEng',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/inquiryDetailEng',
                query: {
                    id: row.id,
                    name: 'banli',
                },
            });
        }
    }
    copAdd() {
        sessionStorage.setItem('SingleInquiryEng_isActive', JSON.stringify(this.isActive));
        if (this.selectionRow.length != 0) {
            this.$router.push({
                path: '/addInquiryEng',
                query: {
                    type: 'copy',
                    id: this.selectionRow[0].id,
                },
            });
        } else {
            this.$router.push({
                path: '/addInquiryEng',
                query: {},
            });
        }
    }
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    confirmOk2() {
        ProjectInquiry.DelProjectInquiry(this.data1).then(() => {
            this.$message.success('询价单删除成功');
            this.getInquiryList();
        });
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public data1: any = null;
    public handleDelete(data) {
        this.data1 = data;
        this.dialogConfig2 = {
            title: '删除询价单',
            show: true,
        };
        // this.$confirm('确认删除该询价单?', '询价单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         ProjectInquiry.DelProjectInquiry(data).then(() => {
        //             this.$message.success('询价单删除成功');
        //             this.getInquiryList();
        //         });
        //     })
        //     .catch(() => {});
    }
    confirmOk3() {
        ProjectInquiry.EndProjectInquiry(this.data2).then(() => {
            this.$message.success('询价单终结成功');
            this.getInquiryList();
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    public data2: any = null;
    public handleFinal(data) {
        this.data2 = data;
        this.dialogConfig3 = {
            title: '终结询价单',
            show: true,
        };
        // this.$confirm('确认终结该询价单?', '询价单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         ProjectInquiry.EndProjectInquiry(data).then(() => {
        //             this.$message.success('询价单终结成功');
        //             this.getInquiryList();
        //         });
        //     })
        //     .catch(() => {});
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData = JSON.parse(localStorage.getItem('SingleInquiry'))
        ? JSON.parse(localStorage.getItem('SingleInquiry'))
        : [
              { title: '询价编号', isShow: true, disabled: false },
              { title: '发货企业', isShow: true, disabled: false },
              { title: '项目编号', isShow: true, disabled: false },
              { title: '项目名称', isShow: true, disabled: false },
              { title: '询价方式', isShow: true, disabled: false },
              { title: '是否开票', isShow: true, disabled: false },
              { title: '报价截止时间', isShow: true, disabled: false },
              { title: '询价状态', isShow: true, disabled: false },
              { title: '发布时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('SingleInquiry', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
            startTime: '',
            endTime: '',
            code: '',
            inquiryWay: '',
            statusListStr: '',
            projectCode: '',
            projectName: '',
            orderBy: '',
        };
        this.statusArr = [];
        this.timeList = [];
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.resetSize();
        this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
    }
}
